import { Injectable } from '@angular/core';
import { catchError, map, withLatestFrom, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';

import { InstitutionProgramDataService } from '@cpd-app/core-module/services';

import { AppState } from '..';
import * as InstitutionProgramActions from './institution-program.actions';
import * as InstitutionActions from '../institution/institution.actions';
import * as InstitutionSelectors from '../institution/institution.selectors';
import * as InstitutionProgramSelectors from './institution-program.selectors';
import * as OccupationDetailSelectors from '../occupation-detail/occupation-detail.selectors';

@Injectable()
export class InstitutionProgramEffects {
  setSelectedInstitution$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InstitutionActions.setSelectedInstitution),
      map(() => InstitutionProgramActions.loadInstitutionPrograms())
    );
  });

  loadInstitutionPrograms$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InstitutionProgramActions.loadInstitutionPrograms),
      withLatestFrom(
        this.store.pipe(
          select(InstitutionSelectors.selectSelectedInstitutionId)
        ),
        this.store.pipe(
          select(OccupationDetailSelectors.selectOccupationDetail)
        ),
        this.store.pipe(
          select(
            InstitutionProgramSelectors.selectProgramsForInstitutionOptions
          )
        )
      ),
      switchMap(
        ([
          action,
          selectedInstitutionId,
          { onetCode },
          programsForInstitutionOptions
        ]) =>
          this.institutionProgramDataService
            .getInstitutionPrograms(
              selectedInstitutionId,
              onetCode,
              programsForInstitutionOptions
            )
            .pipe(
              map((institutionPrograms) =>
                InstitutionProgramActions.loadInstitutionProgramsSuccess({
                  institutionPrograms
                })
              ),
              catchError((error) =>
                of(
                  InstitutionProgramActions.loadInstitutionProgramsFailure({
                    error
                  })
                )
              )
            )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private institutionProgramDataService: InstitutionProgramDataService,
    private store: Store<AppState>
  ) {}
}
